import { getLeadContext } from './leadContext';
import { trackLeadConversion } from './trackLeadConversion';

const DEFAULT_RECIPIENT = 'hello@appivorous.com';
const DEFAULT_CC = 'marketing@appivorous.com,appivorousmarketing@gmail.com';

export async function submitLead(formName, fields, options = {}) {
  const recipient = options.recipient || DEFAULT_RECIPIENT;
  const leadContext = await getLeadContext();
  const payload = {
    _subject: `${formName} | Appivorous website`,
    _template: 'table',
    _captcha: 'false',
    ...(options.cc === false ? {} : { _cc: options.cc || DEFAULT_CC }),
    form: formName,
    submittedAt: `${new Date().toLocaleString('en-GB', {
      timeZone: 'Asia/Karachi',
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true,
    })} (Pakistan time, UTC+05:00)`,
    ...fields,
    ...leadContext,
    _url: window.location.href,
  };

  const response = await fetch(`https://formsubmit.co/ajax/${encodeURIComponent(recipient)}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) throw new Error('Unable to send your request right now.');

  const result = await response.json();
  if (result?.success !== true && result?.success !== 'true') {
    const message = typeof result?.message === 'string' && result.message.trim()
      ? result.message
      : 'Your request was not accepted. Please try again.';
    const error = new Error(message);
    error.userMessage = message;
    throw error;
  }
  await trackLeadConversion();
  window.location.assign('/thankyou');
  return result;
}
